import { defineComponent as x, computed as s, openBlock as t, createBlock as l, TransitionGroup as g, withCtx as k, createElementBlock as o, Fragment as w, renderList as y, normalizeStyle as C, normalizeClass as B, createElementVNode as i, createCommentVNode as a, toDisplayString as c, createVNode as b } from "vue";
import m from "./index60.js";
const z = { class: "flex min-w-0 flex-1 items-center gap-1 overflow-hidden" }, N = { class: "flex shrink-0 items-center gap-2" }, T = {
  key: 1,
  class: "text-font-13 m-0 font-semibold leading-[1.4] tracking-[-0.35px]"
}, V = ["title"], $ = ["onClick"], F = /* @__PURE__ */ x({
  __name: "BaseClosableToast",
  props: {
    toasts: { default: () => [] },
    width: { default: "400px" },
    showCloseButton: { type: Boolean, default: !0 }
  },
  emits: ["remove"],
  setup(d, { emit: u }) {
    const n = d, p = u, f = (r) => {
      p("remove", r);
    }, h = s(() => n.toasts), _ = s(() => n.width), v = s(() => n.showCloseButton);
    return (r, j) => (t(), l(g, {
      name: "toast-stack",
      tag: "div",
      class: "flex flex-col items-end gap-3"
    }, {
      default: k(() => [
        (t(!0), o(w, null, y(h.value, (e) => (t(), o("div", {
          key: e.id,
          class: B(["pointer-events-auto relative flex items-center justify-between gap-1 rounded-sm p-2", [`toast-${e.variant || "info"}`]]),
          style: C({ width: _.value })
        }, [
          i("div", z, [
            i("div", N, [
              e.icon ? (t(), l(m, {
                key: 0,
                name: e.icon,
                color: "",
                size: 16
              }, null, 8, ["name"])) : a("", !0),
              e.title ? (t(), o("h3", T, c(e.title), 1)) : a("", !0)
            ]),
            i("p", {
              class: "text-font-13 m-0 min-w-0 flex-1 truncate font-normal leading-[1.4] tracking-[-0.35px]",
              title: e.message
            }, c(e.message), 9, V)
          ]),
          v.value ? (t(), o("button", {
            key: 0,
            class: "flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0 opacity-70 transition-opacity duration-200 hover:opacity-100",
            onClick: (E) => f(e.id),
            "aria-label": "닫기"
          }, [
            b(m, {
              name: "icn-delete",
              color: "var(--input-icon-off)",
              size: 16
            })
          ], 8, $)) : a("", !0)
        ], 6))), 128))
      ]),
      _: 1
    }));
  }
});
export {
  F as default
};
